"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var CommonContainer = function (props) {
    var _a;
    // 解析props属性
    var _b = props.className, className = _b === void 0 ? '' : _b, flexTitle = props.flexTitle, _c = props.style, style = _c === void 0 ? {} : _c, paddingTopNum = props.paddingTopNum, paddingBottomNum = props.paddingBottomNum, isPadding = props.isPadding, isFooterPart = props.isFooterPart, isCombination = props.isCombination, children = props.children;
    // 获取样式的通用前缀
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var prefixClassName = "".concat(classPrefix, "-common");
    var paddingTopPc = paddingTopNum ? "padding-top-pc-".concat(paddingTopNum) : '';
    var paddingBottomPc = paddingBottomNum ? "padding-bottom-pc-".concat(paddingBottomNum) : '';
    var notFooterPart = isCombination && !isFooterPart && !paddingBottomNum; // 组合类型&非尾部组件
    var combination = isCombination && !paddingTopNum; // 组合类型
    return (react_1.default.createElement("section", { className: "".concat(className, " ").concat(prefixClassName), style: style },
        react_1.default.createElement("div", { className: "".concat(prefixClassName, "__container") },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(prefixClassName, "__wrap ").concat(paddingTopPc, " ").concat(paddingBottomPc), (_a = {},
                    _a["".concat(prefixClassName, "__wrap-title")] = flexTitle,
                    _a["".concat(prefixClassName, "__wrap-padding")] = isPadding,
                    _a["".concat(prefixClassName, "__wrap-footer")] = notFooterPart,
                    _a["".concat(prefixClassName, "__wrap-combination")] = combination,
                    _a)) }, children))));
};
exports.default = CommonContainer;
//# sourceMappingURL=CommonContainer.js.map